<div *ngFor="let type of pest_diseases">
  {{type.name}}:
  <span *ngFor="let item of type.items; let i=index">{{item.name}}<em *ngIf="item.latin_name"> ({{item.latin_name}})</em>{{(i==type.items.length-1) ? '' : ', '}}</span>
</div>